/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
// @mui material components
import Grid from "@mui/material/Grid";
import MDButton from "components/MDButton";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import { apiPost } from "lib/api";

function Dashboard() {
  const navigate = useNavigate();
  const [sales, setSales] = useState("");
  const [facturacionmes,setFacturacionmes] = useState(0)
  const [cantidadmotores,setCantidadmotores] = useState(0)
  const [financiado,setFinanciado] = useState(0)
  const [pagos,setPagos] = useState(0)
  const [incautos,setIncautos] = useState(0)
  const [gastos,setGastos] = useState(0)
  const [barchart,setBarchart] = useState("")
  const [ventas,setVentas] = useState("")


  useEffect(() => {

    //recuperar el total de facturacion del mes
    if(localStorage.getItem("roleweb")=="AdmG"){
    apiPost('/api/facturacionultimomes', {"sucursal": " ",'password':localStorage.getItem("password"),'usuario':localStorage.getItem('usuario')})
      .then(function({ status, data }){
        if (status === 200) {
               //rows = [data["facturacion"]]
               //rows1 = [{id: '2', fecha: '2023-01-01',nombres: 'manuel',apellidos: 'asdasdsa',chasis: 'aaaa',financia:'2500.00' }]
               setFacturacionmes(data['facturacion'][0]['precio']==null?0:data['facturacion'][0]['precio'])
               setCantidadmotores(data['facturacion'][0]['cantidad']==null?0:data['facturacion'][0]['cantidad'])
               setFinanciado(data['prestamo'][0]['valor']==null?0:data['prestamo'][0]['valor'])
               setPagos(data['pagos'][0]['valor']==null?0:data['pagos'][0]['valor'])
               setIncautos(data['incautos'][0]['valor']==null?0:data['incautos'][0]['valor'])
               setGastos(data['gastos'][0]['valor']==null?0:data['gastos'][0]['valor'])

               //crear objeto barchart
               var barchar = new Object()
               barchar.labels = data['datachart']['label']
               barchar.datasets = {label: "Ventas", data: data['datachart']['valor']}
               setBarchart(barchar)

               var mesvalor = new Object()
               mesvalor.labels = data['mesvalor']['label']
               mesvalor.datasets = {label: "Motores Facturados",data: data['mesvalor']['valor']}
               setSales(mesvalor)

               var pagosmesvalor = new Object()
               pagosmesvalor.labels = data['pagosvalor']['label']
               pagosmesvalor.datasets = {label: "Pagos Mensuales", data: data['pagosvalor']['valor']}
               setVentas(pagosmesvalor)
        }
        if (status === 400) {
              alert(data["Error"])
        }
    })
  }
  
  }, []);

  return (
    <MDBox sx={{ p: { xs: 2, md: 3 }, width: "100%" }}>
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="weekend"
                title="Facturacion/Mes"
                count={facturacionmes.toLocaleString("en-US", {style:"currency", currency:"USD"})}
                percentage={{
                  color: "success",
                  label: "Facturacion Ult. Mes",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="leaderboard"
                title="Motores Vendidos"
                count={cantidadmotores}
                percentage={{
                  color: "success",
                  label: "Mes Actual",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="store"
                title="Financiado"
                count={financiado.toLocaleString("en-US", {style:"currency", currency:"USD"})}
                percentage={{
                  color: "success",
                  label: "Ultimo mes",
                }}
              />
            </MDBox>
          </Grid>
        
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="person_add"
                title="Cobrados"
                count={pagos.toLocaleString("en-US", {style:"currency", currency:"USD"})}
                percentage={{
                  color: "success",
                  label: "Ultimo mes",
                }}
              />
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="person_add"
                title="Total Incautos"
                count={incautos.toLocaleString("en-US", {style:"currency", currency:"USD"})}
                percentage={{
                  color: "success",
                  label: "Ultimo mes",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                icon="person_add"
                title="Total Gastos"
                count={gastos.toLocaleString("en-US", {style:"currency", currency:"USD"})}
                percentage={{
                  color: "success",
                  label: "Ultimo mes",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="info"
                  title="Cobros Ultima Semana"
                  description="Lunes a Viernes"
                  date= {new Date().toDateString()}
                  chart={barchart}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="Ventas Motores"
                  description="ultimo 6 meses"
                  date={new Date().toDateString()}
                  chart={sales}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="dark"
                  title="Cobros Realizados"
                  description="Cobros ultimos 6 meses"
                  date={new Date().toDateString()}
                  chart={ventas}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>

        <MDBox>
          {localStorage.getItem("roleweb")=="AdmG"?
           <MDButton variant="gradient" color="info" onClick={()=>{navigate("/motores/dashaboard")}}>Pantalla Completa</MDButton>
          :''}
        </MDBox>
        
      </MDBox>
      {/*<Footer />*/}
    </MDBox>
  );
    
}

export default Dashboard;
